import { Link, useLocation } from 'react-router-dom';
import { BOOKING_URL } from '@/lib/site';
import { INQUIRY_COPY, inquiryHref, inquiryTopic } from '@/lib/engagements';

export type CTAVariant = 'engineer' | 'scoping';

const CTABand = ({ variant = 'engineer' }: { variant?: CTAVariant }) => {
  const { pathname } = useLocation();
  const fallback = variant === 'scoping' ? 'scoping' : 'other';
  const c = INQUIRY_COPY[inquiryTopic(pathname, fallback)];
  return (
    <section className="site-cta on-forest bg-forest text-cream-light">
      <div className="container grid gap-8 py-16 md:grid-cols-[1fr_auto] md:items-center md:py-20">
        <div className="max-w-2xl">
          <h2 className="text-subhead md:text-headline">{c.heading}</h2>
          <p className="mt-4 text-body">{c.body}</p>
        </div>
        <div className="flex flex-col items-start gap-3 justify-self-start md:items-end md:justify-self-end">
          <Link to={inquiryHref(pathname, fallback)} className="btn-cream">
            {c.label}
          </Link>
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-11 items-center text-small underline underline-offset-[0.3em]">
            or book a 30-minute call
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTABand;
